module.exports = __webpack_public_path__ + "static/media/icon-report-desktop.74c88498.svg";